import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import { debounce } from "../../../utils/debounce"

const ClearSelectionButton = styled.button`
  color: ${props => props.theme.primaryColor};
  border: 0;
  background: none;
  font-weight: normal;
  margin: 10px 0;
  outline: 0 !important;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

class SearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: "",
    }
  }

  static propTypes = {
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
    handleSearchChange: PropTypes.func.isRequired,
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const { theme, t, handleSearchChange } = this.props

    const clearSearch = () => {
      this.search.value = ""
      handleSearchChange({ target: { value: "" } })
    }

    const onChange = (event) => {
      event.persist()
      const d = debounce((e) => {
        handleSearchChange(e)
      }, 1000)

      d(event)
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-8">
            <input
              id="search"
              type="text"
              className="form-control input-sm"
              onChange={onChange}
              placeholder={t("Filters.LocationPopup.Placeholder")}
              ref={(input) => {
                this.search = input
              }}
            />
          </div>
          <div className="col-4">
            <ClearSelectionButton onClick={clearSearch} primaryColor={theme.primaryColor}>
              {t("Filters.LocationPopup.ClearSearch")}
            </ClearSelectionButton>
          </div>
        </div>
      </div>
    )
  }
}
export default translate()(SearchInput)



// WEBPACK FOOTER //
// ./src/components/layout/checkbox-tree/SearchInput.jsx